import type { CandidateRecord } from '../../types/market';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

function tone(contribution: number): 'positive' | 'negative' | 'info' {
  return contribution > 0 ? 'positive' : contribution < 0 ? 'negative' : 'info';
}

export function SupportingMethodsPanel({ candidate }: { candidate?: CandidateRecord }): React.JSX.Element {
  const analysis = candidate?.supportingAnalysis;
  return (
    <Panel
      title="Independent supporting methods"
      description="These methods are separate evidence only. They never replace the Core signal or create a standalone prediction."
    >
      {!analysis ? (
        <div className="notice">Supporting methods have not been evaluated yet. The original Core remains fully independent.</div>
      ) : (
        <div className="attribution-list">
          <div className="subrow-content">
            <div className="subrow-chip">
              <span className="subrow-label">Core score:</span>
              <strong>{candidate.coreScore}/100</strong>
            </div>
            <div className="subrow-chip">
              <span className="subrow-label">Experimental support:</span>
              <strong>{analysis.score >= 0 ? '+' : ''}{analysis.score}</strong>
            </div>
            <div className="subrow-chip">
              <span className="subrow-label">Authority:</span>
              <Badge tone="info">experimental · +1 max/method</Badge>
            </div>
          </div>
          {analysis.methods.map((method) => (
            <div key={method.id} className="subrow-content">
              <div className="subrow-chip">
                <span className="subrow-label">{method.id}</span>
                <strong>{method.name}</strong>
              </div>
              <div className="subrow-chip">
                <Badge tone={tone(method.contribution)}>{method.contribution > 0 ? `+${method.contribution}` : method.contribution}</Badge>
              </div>
              <div className="subrow-chip">
                <span className="subrow-label">Data:</span>
                <span>{method.dataSufficient ? `${method.sampleSize} closed candles` : 'insufficient'}</span>
              </div>
              <div className="subrow-chip subrow-chip-right">
                <span>{method.finding}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
